import { useMemo } from 'react';

import { FeaturedLeague } from '../components/FeaturedLeagueSection';
import { getFeaturedLeagues } from '../utils/navigation-launchpad-utils';
import { useNavigationEntries } from './use-navigation-entries';

export const useFeaturedLeagues = (): FeaturedLeague[] => {
    const { data: entries } = useNavigationEntries();
    return useMemo(() => (entries ? getFeaturedLeagues(entries) : []), [entries]);
};
